<template>
  <section id="first-view">
    <img src="../../assets/first-view009.png" alt="">
    <div class="x-scroll">
      <div class="x-scroll_inner">
        <div class="x-scroll_item"><img src="../../assets/logo/4-1.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/1.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/6.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/3.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/5-1.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/4-1.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/1.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/6.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/3.png" alt=""></div>
        <div class="x-scroll_item"><img src="../../assets/logo/5-1.png" alt=""></div>
      </div>
    </div>
  </section>
</template>

<style scoped>
#first-view img {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}

.x-scroll {
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid #80808033;
  background: rgba(255, 255, 255, 0.868);
}

.x-scroll_inner {
  display: flex;
  width: max-content;
  animation: scrollLoop 30s linear infinite;
}

@keyframes scrollLoop {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.x-scroll_item {
  width: 150px;
  margin: 10px;
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
